import { IGlobalState } from '@/context/reducer';
import { ICartProductGift } from '@/models/cart';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export function useGiftProduct(selling_code: string) {
  const [gift, setGift] = useState<ICartProductGift>();

  const { session } = useSelector<IGlobalState, IGlobalState>(
    state => state || {}
  );

  useEffect(() => {
    if (!isEmpty(session?.cart?.gift_products?.products)) {
      const giftProduct = session?.cart?.gift_products?.products?.find(gift => {
        return (
          gift.selected?.length === 0 &&
          gift.selling_code &&
          gift.selling_code.includes(selling_code)
        );
      });

      setGift(giftProduct);
    }
  }, [selling_code, session?.cart]);

  return gift;
}
